import React from 'react';
// Loading Spinner made by Made by @gagan-gv on
// https://uiverse.io/detail/gagan-gv/nervous-wasp-20

const Spinner = () => {
  return (
    <div className="loading-spinner">
      <span>L</span>
      <span>O</span>
      <span>A</span>
      <span>D</span>
      <span>I</span>
      <span>N</span>
      <span>G</span>
    </div>
  );
};

export default Spinner;
